import React, {FC} from 'react';

import {DraftSummaryModel} from '../../../../../models/api/draftSummaryModel';
import {CellAuthorWrapperProps} from './cellAuthorWrapper';
import {CellCommentLine, CellCommentLineRenderSummaryData, renderSummaryText} from './cellCommentLine';
import {CellSummaryPlaceholder} from './cellSummaryPlaceholder';

/*
 * Props.
 */

export interface CellCommentDraftSummaryProps extends CellAuthorWrapperProps {
  summary: DraftSummaryModel;
  mentionableAliases?: ReadonlySet<string>;
  isSelected?: boolean;
  isUnread?: boolean;
  hasFollowingComments?: boolean;
  isCompact?: boolean;
}

/*
 * Component.
 */

export const CellCommentDraftSummary: FC<CellCommentDraftSummaryProps> = (props) => {
  const {summary} = props;
  return (
    <CellCommentLine
      shouldDisplayDraftStatus
      text={summary.blurb}
      author={props.author}
      mentionableAliases={props.mentionableAliases}
      isSelected={props.isSelected}
      isUnread={props.isUnread}
      hasFollowingComments={props.hasFollowingComments}
      renderSummary={renderSummary}
      shouldDisplayAttachmentIcon={props.summary.hasAttachments}
      annotation={undefined}
      // This follows CellComment's logic for computing shouldUseEllipsisOverflow.
      shouldUseEllipsisOverflow={false} // = Boolean(annotation)
      isCompact={props.isCompact}
    />
  );
};

function renderSummary(data: CellCommentLineRenderSummaryData) {
  const {props, emojiValidationMap} = data;
  const {text, mentionableAliases, isSelected} = props;
  const trimmedText = text.trim();

  // If the comment has text, use it.
  if (trimmedText) {
    return renderSummaryText(trimmedText, emojiValidationMap, isSelected, mentionableAliases);
  }

  // Otherwise, render a placeholder.
  return <CellSummaryPlaceholder />;
}
